var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.survey),function(item,idx){return _c('div',{key:idx},[_c('span',[_c('p',{staticClass:"bold title"},[_vm._v(_vm._s(idx + 1)+". "+_vm._s(item.title)),_c('i',{staticClass:"red"},[_vm._v("*")])]),_c('div',{staticClass:"answer"},[_vm._v(_vm._s(item.value))]),_c('p')])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }